import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Layout, Menu, Skeleton, Badge, Drawer } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { size, times, map, intersection, get, filter, concat } from "lodash";
import insytslogo from "../assets/InsytsLogoSidebar.svg";
import _map from "lodash/map";
import COLORS from "common/Colors";
import Icon from "../atoms/Icon";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getLoadingDataFirstTime,
  getUnreadChatMessageList,
  getDepartmentUserList,
  getUserInfo,
  getUserList,
  getClientid,
  getRoleList,
  getUserRole,
  getActiveMenuList,
} from "redux/selectors";
import { DEVICE } from "common/Device";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ActiveIcons from "atoms/ActiveIcons";

const { Item, SubMenu } = Menu;

const StyledLogo = styled.div`
  height: 70px;
  width: 80px;
  margin: 5px 15px 20px;
  text-align: center;
  background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
  img {
    margin-top: 5px;
  }
  @media ${DEVICE.tablet} {
    height: 25px;
    margin-bottom: 15px;
    img {
      height: 25px !important;
    }
  }
`;

const StyledSubMenu = styled(SubMenu)`
  background: ${COLORS.SIDEBAR};
  color: ${COLORS.TEXT.SECONDARY} !important ;

  svg {
    color: ${COLORS.TEXT.SECONDARY};
    fill: ${COLORS.TEXT.SECONDARY};
  }
`;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background: ${COLORS.SIDEBAR};
    border: none;
  }
  .ant-menu.ant-menu-dark,
  .ant-menu-dark .ant-menu-sub,
  .ant-menu.ant-menu-dark .ant-menu-sub {
    color: ${COLORS.TEXT.SECONDARY};
    background: ${COLORS.SIDEBAR};
  }
  .ant-drawer-close {
    color: ${COLORS.TEXT.SECONDARY};
  }
  .ant-drawer-body {
    ::-webkit-scrollbar-thumb {
      background-color: ${COLORS.PRIMARY};
      border-radius: 6px;
      font-size: 16px;
    }
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  .ant-menu {
    background: ${COLORS.SIDEBAR};
  }
`;

const StyledMenuItem = styled(Item)`
  vertical-align: middle;
  border-radius: 10px;
  width: 100%;
  background: "${COLORS.SIDEBAR}";
  color: ${COLORS.TEXT.SECONDARY} !important ;
  border: none !important;
  font-size: 16px !important;
  svg {
    color: none !important;
    fill: none !important;
  }
  path {
    color: ${COLORS.TEXT.SECONDARY};
  }
  .ant-menu {
    border: 0 !important;
  }

  .MuiSvgIcon-root {
    color: ${COLORS.TEXT.SECONDARY} !important;
  }
  &:after {
    border-right: 3px solid
      ${(props) => (props.selected ? `${COLORS.PRIMARY}` : `${COLORS.SIDEBAR}`)} !important;
  }
  &.ant-menu-item a,
  .ant-menu-item a:hover,
  .ant-menu-item a:active {
    color: #000000 !important;
  }

  &.ant-menu-item-selected a,
  .ant-menu-item-selected a:hover,
  .ant-menu-item-selected a:active {
    color: #00685F !important;
    font-weight: 600;
  }
  &.ant-menu-item-selected {
    color: ${(props) => props.selected ? `${COLORS.TEXT.SECONDARY}` : `${COLORS.TEXT.SECONDARY}`};
    background-color: ${(props) => props.selected ? "#DEEFEE" : "inherit"} !important;
      border-radius: 5px 0px 0px 5px !important;
    .anticon,a,svg {
      color: "${COLORS.TEXT.SECONDARY}";
      fill: ${(props) => props.selected ? "#00685F" : `${COLORS.TEXT.SECONDARY}`};
    }
  }
`;

const StyledMenuSkeletonContainer = styled.div`
  text-align: center;
  padding: 10px 20px;
  .ant-skeleton {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const Container = styled.div`
  color: ${COLORS.TEXT.SECONDARY};
  ::-webkit-scrollbar-thumb {
    background-color: "#FFFFFF33";
    border-radius: 6px;
    font-size: 1px;
  }
  .ant-layout-sider-children {
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    margin: 0;
    color: ${COLORS.TEXT.SECONDARY};
  }

  .ant-menu-submenu-title > .anticon {
    color: "#fff"; /* Set your desired color */
    fill:  "#fff";
  }
  .ant-menu {
    font-size: 14px;
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    color: ${COLORS.TEXT.SECONDARY};
  }
  .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: ${COLORS.SIDEBAR};
  }
  overflow-y: auto;
  overflow-x: hidden;
  .sidemenu {
    display: none;
  }
  .hidemenu {
    display: flex;
    width: max-content;
    height: 100%;
    padding: 10px;
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    flex-direction: column;
    justify-content: space-between;
    border-right: 2px solid #E2E2E8;
    p {
      font-weight: bold;
      padding-left: 5%;
    }
  }
  .hidemenu1 {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: space-between;
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    p {
      font-weight: bold;
      padding-left: 5%;
      margin-top: 10%;
    }
  }
  @media ${DEVICE.tablet} {
    .sidemenu {
      width: 150px;
      height: 100vh;
      display: flex;
      justify-content: center;
      position: fixed;
      top: 110px;
      transition: 350ms;
      z-index: 20;
      background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    }
    .hidemenu {
      display: none;
      padding: 10px;
    }
  }
`;

const StyledBadge = styled(Badge)`
  left: 10px;
  top: 4px;
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  .ant-badge-dot {
    width: 10px;
    height: 10px;
    animation: blinker 1s linear infinite;
  }
`;

const HoverFlyoutWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  color: ${COLORS.TEXT.SECONDARY};
  border-radius: 10px;
  gap: 10px;
  font-size: 14px;

  &:hover {
    background-color: ${COLORS.PRIMARY}22;
  }

  &.active {
    background-color: #DEEFEE;
    border-right: 3px solid ${COLORS.PRIMARY};
    border-radius: 5px 0px 0px 5px !important;
    .folder-label {
      color: #00685F;
      font-weight: 600;
    }
  }
  overflow: visible;
  .folder-label {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    color: ${COLORS.TEXT.SECONDARY};
    padding-left: 8px;
  }
`;

const { Sider } = Layout;

const FolderFlyout = ({ myFolderMenu, setPageTitle, isActive, activePage }) => {
  const folderRef = useRef(null);
  const [flyoutPos, setFlyoutPos] = useState(null);

  const handleMouseEnter = () => {
    if (folderRef.current) {
      const rect = folderRef.current.getBoundingClientRect();
      setFlyoutPos({ top: rect.top - 130, left: rect.right - 20 });
    }
  };
  const handleMouseLeave = () => setFlyoutPos(null);

  return (
    <HoverFlyoutWrapper
      ref={folderRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={isActive ? "active" : ""}
    >
      <div className="folder-label">
        {
          isActive ? <ActiveIcons name="document" /> : <Icon name="document" />
        }
        <span>My Folder</span>
      </div>
      {flyoutPos && ReactDOM.createPortal(
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            position: "fixed",
            top: flyoutPos.top,
            left: flyoutPos.left,
            background: COLORS.SIDEBAR,
            borderRadius: 8,
            boxShadow: "4px 4px 16px rgba(0,0,0,0.25)",
            minWidth: 160,
            zIndex: 99999,
            padding: "4px 0",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {myFolderMenu.subMenu.map((item) => {
            const isItemActive = activePage === item.path;
            return (
              <Link
                key={item.key}
                to={`/${item.path}`}
                onClick={() => { setPageTitle(item.title); setFlyoutPos(null); }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 16px",
                  color: isItemActive ? "#00685F" : COLORS.TEXT.SECONDARY,
                  fontSize: 13,
                  textDecoration: "none",
                  fontWeight: isItemActive ? 600 : 400,
                  background: isItemActive ? "#DEEFEE" : "transparent",
                  borderRadius: 6,
                  margin: "0 4px",
                }}
              >
                <Icon name={item.icon} />
                {item.title}
              </Link>
            );
          })}
        </div>,
        document.body
      )}
    </HoverFlyoutWrapper>
  );
};
const OtherEntitiesMenuItem = ({ setPageTitle, isActive, items }) => {
  const firstItem = items[0];
  if (!firstItem) return null;
  return (
    <HoverFlyoutWrapper
      className={isActive ? "active" : ""}
      onClick={() => setPageTitle("Other Entities")}
    >
      <Link
        to={`/${firstItem.path}`}
        style={{ textDecoration: "none", width: "100%" }}
      >
        <div className="folder-label">
          {isActive ? <ActiveIcons name="billingentity" /> : <Icon name="billingentity" />}
          <span>Other Entities</span>
        </div>
      </Link>
    </HoverFlyoutWrapper>
  );
};
const SideBar = ({
  defaultKey,
  collapsed,
  setPageTitle,
  userRoleId,
  isLoadingDataFirstTime,
  unreadChatMessageList,
  open,
  onClose,
  userInfo,
  userList,
  activeMenuList,
  clientId,
}) => {
  const activePage =
    useLocation().pathname.replace(/^\/+|\/+$/g, "") || "dashboard";

  let Menulist =
    activeMenuList?.[userRoleId] ||
    Object.values(activeMenuList)?.[0] ||
    activeMenuList;

  Menulist = Array.isArray(Menulist) ? Menulist : [];

  const filtermenulist =
    (Menulist &&
      Menulist.filter(
        (data) =>
          data.key !== "managerdashboard" &&
          data.key !== "hrdashboard" &&
          data.key !== "managerappraisal" &&
          data.key !== "teamcalendar" &&
          data.key !== "allcalendar" &&
          data.key !== "regionalchart" &&
          data.key !== "officechart" &&
          data.key !== "employeeperformance" &&
          data.key !== "exemployee" &&
          data.key !== "pendingapprovalstimesheet" &&
          data.key !== "declinedtimesheet" &&
          data.key !== "timesheetapprovals" &&
          data.key !== "billingapprovals" &&
          data.key !== "matterrequest" &&
          data.key !== "fundrequest" &&
          data.key !== "myeventcalendar" &&
          data.key !== "alleventcalendar" &&
          data.key !== "myengagementcalendar" &&
          data.key !== "teamengagementcalendar" &&
          data.key !== "allengagementcalendar" &&
          data.key !== "capacityresourceplanning" &&
          data.key !== "PFAapprovals" &&
          data.key !== "myappraisal" &&
          data.key !== "appraisal" &&
          data.key !== "performance" &&
          data.key !== "myteam" &&
          data.key !== "mydocuments" &&
          data.key !== "mydeclaration" &&
          data.key !== "leavereport" &&
          data.key !== "companypolicy" &&
          data.key !== "billingentity" &&
          data.key !== "subcontractors" &&
          data.key !== "myplanner"
      )) ||
    [];

  // Virtual "My Folder" group combining myteam, mydocuments, mydeclaration, leavereport
  const myFolderItems = [
    { key: "myteam", path: "myteam", title: "Team", },
    { key: "mydocuments", path: "mydocuments", title: "Documents", },
    { key: "mydeclaration", path: "mydeclaration", title: "Declaration", },
    { key: "leavereport", path: "myleavereport", title: "History", },
    { key: "companypolicy", path: "companypolicy", title: "Company Policy", },
  ].filter((item) =>
    Menulist.some((m) => m.key === item.key && m.access)
  );

  const myFolderMenu = myFolderItems.length > 0
    ? {
      key: "myfolder",
      title: "My Folder",
      icon: "document",
      subMenu: myFolderItems,
    }
    : null;

  const otherEntitiesItems = [
    { key: "billingentity", path: "billingentity", title: "Billing Entity", icon: "billingentity" },
    { key: "subcontractors", path: "subcontractors", title: "Subcontractors", icon: "billingentity" },
  ].filter((item) =>
    Menulist.some((m) => m.key === item.key && m.access) ||
    Menulist.some((m) =>
      m.subMenu && m.subMenu.some((sub) => sub.key === item.key && sub.access)
    )
  );

  const calendarAccess =
    (Menulist &&
      Menulist.filter(
        (data) =>
          data.key === "mycalendar" ||
          data.key === "teamcalendar" ||
          data.key === "allcalendar" ||
          data.key === "myengagementcalendar" ||
          data.key === "teamengagementcalendar" ||
          data.key === "allengagementcalendar"
      )) ||
    [];

  // ── FIXED: dashboard's own access is now derived from its own entry
  // in Menulist instead of borrowing hrdashboard/managerdashboard, which
  // was causing the "Home" item to render as a live Link even when the
  // user had no real access — leading to a 403 after navigation instead
  // of the item simply being disabled up front. ──
  const dashboardMenuEntry = Menulist.find((data) => data.key === "dashboard");
  const canViewDashboard = dashboardMenuEntry
    ? !!dashboardMenuEntry.access && dashboardMenuEntry?.permission?.view !== false
    : false;

  const TeamAppraisalAccess =
    (Menulist && Menulist.filter((data) => data.key === "managerappraisal")) ||
    [];

  const peopleAccess =
    (Menulist &&
      Menulist.filter(
        (data) =>
          data.key === "regionalchart" ||
          data.key === "exemployee" ||
          data.key === "officechart" ||
          data.key === "employeeperformance"
      )) ||
    [];

  const timesheetAccess = Menulist.filter(
    (data) =>
      data.key === "mytimesheet" ||
      data.key === "pendingapprovalstimesheet" ||
      data.key === "declinedtimesheet"
  );

  const approvalsAccess = Menulist.filter(
    (data) =>
      data.key === "approvals" ||
      data.key === "timesheetapprovals" ||
      data.key === "billingapprovals" ||
      data.key === "PFAapprovals" ||
      data.key === "matterrequest"
  );

  const resourcePlanningAccess = Menulist.filter(
    (data) => data.key === "peopleresourceplanning"
    // || data.key === "capacityresourceplanning"
  );

  const canViewApprovals = approvalsAccess.some((menu) => menu.permission.view);

  const canViewResourcePalnning = resourcePlanningAccess.some(
    (menu) => menu.permission.view
  );

  const canViewTimesheet = timesheetAccess.some((menu) => menu.permission.view);

  const canViewCalendar = calendarAccess.some((menu) => menu.permission.view);

  const canViewAppraisal = TeamAppraisalAccess.some(
    (menu) => menu.permission.view
  );
  const canViewPeople = peopleAccess.some((menu) => menu.permission.view);

  const menuSkeleton = (key) => (
    <Skeleton.Input block={true} active={true} size="small" key={key} />
  );
  const location = useLocation();

  const unreadDot = () => {
    var hrUser = filter(userList, { roleid: 1 });

    if (userRoleId == 2) {
      let result = map(
        concat(
          filter(userList, {
            departmentid: get(userInfo, "staff_department_id", ""),
          }),
          hrUser
        ),
        (e) => e.userid
      );
      result = intersection(result, unreadChatMessageList);
      return size(result) ? true : false;
    }
    return size(unreadChatMessageList) ? true : false;
  };

  const logoStyle = {
    height: collapsed ? "35px" : "57px",
    width: collapsed ? "80px" : "auto",
    marginTop: collapsed ? "30px" : "0px",
    // marginLeft: collapsed ? "-30px" : "",
  };

  const containerStyle = {
    height: "100vh",
    background: `${COLORS.SIDEBAR}`,
  };

  const drawerStyle = {
    padding: "0px",
    background: `${COLORS.SIDEBAR} 0% 0% no-repeat padding-box`,
  };

  // ── NEW: resolves the display label for a top-level menu item.
  // Pulled out so both the clickable branch and the disabled branch
  // render identical text. "dashboard" now displays as "Home". ──
  const getMenuLabel = (menu) => {
    switch (menu?.key) {
      case "mycalendar":
        return "Calendar";
      case "dashboard":
        return "Dashboard";
      case "mineappraisal":
        return "Performance";
      case "employee":
        return "People";
      case "mytimesheet":
        return "Timesheet";
      case "approvals":
        return "Approvals";
      case "peopleresourceplanning":
        return "Resource Planning";
      case "currency":
        return "Currency";
      default:
        return menu?.title;
    }
  };

  // ── NEW: resolves whether a given top-level menu item is actually
  // clickable for this user. Centralizes the same access checks that
  // used to live only inside the render filter, so they can also be
  // used to decide clickable vs disabled per item. ──
  const getMenuAccess = (menu) => {
    switch (menu?.key) {
      case "mycalendar":
        return canViewCalendar;
      case "employee":
        return canViewPeople;
      case "dashboard":
        return canViewDashboard;
      case "managerappraisal":
        return canViewAppraisal;
      case "mytimesheet":
        return canViewTimesheet;
      case "approvals":
        return canViewApprovals;
      case "peopleresourceplanning":
        return canViewResourcePalnning;
      default:
        return !!menu?.access;
    }
  };

  const MenuComponent = !isLoadingDataFirstTime && (
    <Menu
      theme="light"
      mode="inline"
      defaultSelectedKeys={[activePage]}
      defaultOpenKeys={[defaultKey]}
    >
      {_map(
        filtermenulist?.filter(
          (menu) =>
            menu.icon !== "" &&
            (
              menu?.access ||
              menu.key === "mycalendar" ||
              menu.key === "employee" ||
              menu.key === "dashboard" ||
              menu.key === "managerappraisal" ||
              menu.key === "mytimesheet" ||
              menu.key === "approvals" ||
              menu.key === "peopleresourceplanning"
            )
        ),
        (menu) => {
          const lastModule = localStorage.getItem("lastActiveModule");
          const profileType = new URLSearchParams(location.search).get("type");
          const checkid = activePage?.includes("client-details")
            ? "client"
            : activePage?.includes("profile-details")
              ? (profileType === "hr" ? "team" : "employee")
              : activePage?.includes("client-detail") || activePage?.includes("client-new")
                ? "client"
                : activePage?.includes("matter-details") || activePage?.includes("create-matter")
                  ? "matter"
                  : activePage?.includes("timesheet-detailed")
                    ? "approvals"
                    : activePage?.includes("ViewIncident")
                      ? "myincident"
                      : activePage?.includes("viewincidentlog")
                        ? "incidentlog"
                        : activePage?.includes("Agreed") || activePage?.includes("awaitngresponse") || activePage?.includes("reviewagree")
                          ? "performancemanagement"
                          : activePage?.includes("my-profile")
                            ? lastModule
                            : activePage?.includes("announcement") ||
                              activePage?.includes("add-edit-announcement") ||
                              activePage?.includes("announcement-details")
                              ? "dashboard"
                              : "";
          const isSelected = activePage === menu.path || checkid === menu.path;

          // NOTE: items without access (e.g. Home/"dashboard" when the
          // user lacks permission) are still rendered as normal clickable
          // links here. The sidebar always stays fully visible/clickable;
          // access is enforced at the route level instead, which renders
          // a 403 page in the content area when the destination is
          // reached without permission. See <ForbiddenRoute> / Forbidden403.

          return menu?.subMenu && menu?.subMenu?.length > 0 ? (
            <StyledSubMenu
              key={menu?.key}
              title={menu?.title}
              icon={menu?.icon && <Icon name={menu?.icon} />}
            >
              {_map(
                menu?.subMenu.filter((submenu) => submenu?.access),
                (submenu) => {
                  const isSubSelected = location?.pathname.substr(1) === submenu?.path;

                  return submenu?.subMenu && submenu?.subMenu?.length > 0 ? (
                    <StyledSubMenu
                      key={submenu?.key}
                      icon={submenu?.icon && (isSubSelected
                        ? <ActiveIcons name={submenu?.icon} />
                        : <Icon name={submenu?.icon} />
                      )}
                      title={submenu?.title}
                    >
                      {_map(
                        submenu?.subMenu.filter((submenu) => submenu?.access),
                        (submenu) => {
                          return (
                            <StyledMenuItem
                              collapsed={collapsed ? "true" : "false"}
                              key={submenu?.key}
                              icon={
                                submenu?.icon && <Icon name={submenu?.icon} />
                              }
                              onClick={() => {
                                setPageTitle(menu?.title);
                                localStorage.setItem("lastActiveModule", menu?.path);
                              }}
                              selected={
                                location?.pathname.substr(1) == ""
                                  ? false
                                  : true
                              }
                            >
                              <Link to={`/${submenu.path}`}>
                                {submenu?.title}
                              </Link>
                              <StyledBadge
                                dot={menu?.path === "team" && unreadDot()}
                              />
                            </StyledMenuItem>
                          );
                        }
                      )}
                    </StyledSubMenu>
                  ) : (
                    <>
                      {submenu.key !== "attendance-report-monthly" && (
                        <StyledMenuItem
                          collapsed={collapsed ? "true" : "false"}
                          key={submenu?.key}
                          icon={submenu?.icon && <Icon name={submenu?.icon} />}
                          onClick={() => setPageTitle(submenu?.title)}
                          selected={
                            location?.pathname.substr(1) == "" ? false : true
                          }
                        >
                          <Link to={`/${submenu?.path}`}>{submenu?.title}</Link>
                          <StyledBadge
                            dot={menu?.path === "team" && unreadDot()}
                          />
                        </StyledMenuItem>
                      )}
                    </>
                  );
                }
              )}
            </StyledSubMenu>
          ) : (
            <StyledMenuItem
              key={menu?.key}
              icon={menu?.icon && (isSelected
                ? <ActiveIcons name={menu?.icon} />
                : <Icon name={menu?.icon} />
              )}
              onClick={() => {
                setPageTitle(menu?.title);
                localStorage.setItem("lastActiveModule", menu?.path);
              }}
              selected={isSelected}
              className={`${isSelected ? "ant-menu-item-selected" : ""}`}
            >
              <Link to={`/${menu?.path}`}>
                {getMenuLabel(menu)}
              </Link>
              <StyledBadge dot={menu?.path === "team" && unreadDot()} />
            </StyledMenuItem>
          );
        }
      )}
      {myFolderMenu && (
        <FolderFlyout
          myFolderMenu={myFolderMenu}
          setPageTitle={setPageTitle}
          activePage={activePage}
          isActive={["myteam", "mydocuments", "mydeclaration", "myleavereport", "companypolicy"].includes(activePage)}
        />
      )}
      {otherEntitiesItems?.length > 0 && (
        <OtherEntitiesMenuItem
          items={otherEntitiesItems}
          setPageTitle={setPageTitle}
          isActive={["billingentity", "subcontractors"].includes(activePage)}
        />
      )}
    </Menu>
  );

  return (
    <Container style={containerStyle}>
      <div className="hidemenu">
        <Sider trigger={null} collapsible collapsed={collapsed}>
          {/* <Link to={userRoleId === "1" ? `ownerdashboard` : `dashboard`} onClick={() => setPageTitle("")}> */}
          <StyledLogo>
            <img
              className="mb-3 pb-2"
              style={logoStyle}
              src={userRoleId === "1" ? insytslogo : insytslogo}
              alt="Legal"
            />
          </StyledLogo>
          {/* </Link> */}
          {isLoadingDataFirstTime && (
            <StyledMenuSkeletonContainer>
              {times(10, (ind) => menuSkeleton(ind))}
            </StyledMenuSkeletonContainer>
          )}

          {MenuComponent}
        </Sider>
      </div>
      <div>
        <StyledDrawer
          bodyStyle={drawerStyle}
          width={240}
          title={
            <>
              <Link to={`dashboard`}>
                <img
                  src={userRoleId == 1 ? insytslogo : insytslogo}
                  width={120}
                  alt="Legal"
                />
              </Link>
            </>
          }
          placement="left"
          onClose={onClose}
          open={open}
        >
          {MenuComponent}
        </StyledDrawer>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  isLoadingDataFirstTime: getLoadingDataFirstTime(state),
  unreadChatMessageList: getUnreadChatMessageList(state),
  departmentUserList: getDepartmentUserList(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  // menuList: getMenuList(state),
  activeMenuList: getActiveMenuList(state),
  clientId: getClientid(state),
  roleList: getRoleList(state),
  UserRoleId: getUserRoleId(state),
  roleId: getUserRoleId(state),
  role: getUserRole(state),
});

export default connect(mapStateToProps, null)(SideBar);